import { connect } from 'react-redux';
import AdjustmentJournal from '../../../../views/Finance/Bookkeeping/AdjustmentJournal/AdjustmentJournal.bookkeeping.view';
import { getAdjustmentJournal } from '../../../../states/thunks/finance.thunk';

function mapDispatchToProps(dispatch) {
  return {
    handleGetAdjustmentJournal: payload => dispatch(getAdjustmentJournal(payload)),
  };
}

export default connect(null, mapDispatchToProps)(AdjustmentJournal);
